import Marquee from "react-fast-marquee";
import { Quote } from "lucide-react";

// Real testimonials — sourced from Rise Learning course feedback.
const testimonials = [
  { quote: "I found Liz enthusiastic, knowledgeable, approachable and she delivered the workshop in an informative and positive style." },
  { quote: "Liz is a very skilled trainer who makes it look easy. She took us through the course in a calm and engaging manner whilst ensuring all the content was covered. The course itself is thought provoking and the manual is a very useful resource to have to hand." },
  { quote: "I enjoyed this course thoroughly, I loved the interactive activities provided via the case studies, also how informative our instructor was." },
  { quote: "I took away so much from this training and it definitely surpassed what I expected." },
  { quote: "This was such a good course, very informative and thought provoking." },
  { quote: "I don't generally feel overly comfortable in group sharing and discussion situations but felt at ease with Liz." },
  { quote: "Thank you for such an engaging and inspiring training — the sessions were in-depth and informative and allowed for lots of discussion and collaboration with fellow attendees." },
  { quote: "A really valuable and supportive session. Great to meet people from different organisations and experiences. Excellent session, I could have happily continued the discussions all day." },
  { quote: "Liz was a fantastic trainer, I cannot recommend or praise her enough, she was so good and explained everything perfectly. The course was excellent and I came away with some fantastic tools in order to support not just my colleagues but to use in my everyday life." },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="section relative overflow-hidden bg-[#1E2A25] text-[#EFE8DD]">
      <div className="container-x mb-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-7">
            <p className="eyebrow text-[#D88C76] mb-4">Kind words</p>
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.02] tracking-tight text-[#EFE8DD]">
              From the people <br />
              <span className="italic text-[#D88C76]">in the room.</span>
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9">
            <p className="text-[#EFE8DD]/70 leading-relaxed">
              Real feedback from learners across our MHFA courses.
            </p>
          </div>
        </div>
      </div>

      <div className="marquee-fade">
        <Marquee gradient={false} speed={30} pauseOnHover>
          {testimonials.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="w-[380px] md:w-[460px] mx-4 bg-[#243330] border border-[#8DA399]/20 rounded-3xl p-8 relative flex flex-col"
              style={{ minHeight: "260px" }}
            >
              <Quote className="w-8 h-8 text-[#D88C76]/60 mb-4" strokeWidth={1.4} />
              <p className="font-serif-display text-xl md:text-2xl leading-snug text-[#EFE8DD]">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-auto pt-6 border-t border-[#EFE8DD]/10 text-sm text-[#EFE8DD]/50 italic">
                Feedback from a Rise Learning MHFA course
              </div>
            </article>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
